<template>
  <p class="col-sm">
    {{ $t('hello') }}
    <br/>
    {{ $t('message') }}
    </p>
</template>

<script>
export default {
  name: 'InputTextarea',
};
</script>

<i18n>
{
  "en": {
    "hello": "Hello i18n in SFC! English"
  },
  "de": {
    "hello": "Hello i18n in SFC! German"
  }
}
</i18n>
